/**
 * Name of the cookie holding this app's Supabase session.
 *
 * Cookies are scoped by HOST, not by port — in development this storefront
 * (:3000), the admin panel (:3001) and the driver app (:3002) are all
 * "localhost". With the default name (derived from the shared Supabase URL) all
 * three write the same cookie, so signing in to one silently replaced the
 * others' session. Each app owns a distinct name so their sessions coexist.
 *
 * Every Supabase client in this app MUST pass it — browser, server, proxy and
 * route handlers — or they read a session the others never wrote.
 */
export const AUTH_COOKIE_NAME = 'sb-shop';
